var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"excluor-button square",class:{ 'active': _vm.value, 'disabled': _vm.disabled },on:{"click":_vm.toggle}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }